<template>
    <div>
        <template>
            <template v-for="(vente, i) in hard_coded_programs">
                <l-marker v-if="vente.prog_type !== 'annotation'" :key="'hard' + i" :lat-lng="vente.location" draggable
                    @update:lat-lng="$emit('update_pos_hard_point',$event, i, 'location')" @click="$emit('select_hardcoded',i)">
                    <l-icon :class-name="'custom-marker-selected'">
                        <p class="num">{{ getProgrammeMarkerIndex(i) }}</p>
                    </l-icon>
                </l-marker>
            </template>
        </template>

        <template>
            <v-marker-cluster key="selected-mutations-cluster" ref="selected-mutations-cluster" :options="{
                maxClusterRadius: 50,
                iconCreateFunction: iconCreateClsPrg,
                spiderfyDistanceMultiplier: 3
            }" @click="cluster_prg_click()" @clusterclick="cluster_prg_clusterclick()"
                @spiderfied="cluster_prg_spiderfied()" @unspiderfied="cluster_prg_unspiderfied()">

                <l-marker v-for="(mutation, i) in selected_mutations" :key="'selected-mut-num-' + mutation.id"
                    :lat-lng="mutation.pin_position || [0, 0]"
                    @update:lat-lng="update_pos_mutation(mutation, $event, 'pin')" draggable
                    @click="$emit('toggleSelectedMutations', mutation)">
                    <l-icon :class-name="'custom-marker-selected' + ' i_' + (i + 1)">
                        <p class="num">{{ i + 1 }}</p>
                    </l-icon>
                </l-marker>
            </v-marker-cluster>
            <l-marker v-for="(mutation, i) in selected_mutations" v-if="!linkedToView && !view"
                :key="'selected-mut-' + mutation.id" :lat-lng="mutation.popup_position || [0, 0]"
                @update:lat-lng="update_pos_mutation(mutation, $event, 'popup')" draggable>
                <l-icon class-name="selected-card selected-card--mutation">
                    <q-card class="selected">
                        <q-card-section class="q-card__section--rouge">
                            <p class="name">
                                <strong>Type :</strong> {{ getMutationType(mutation) }}
                            </p>
                            <p>
                                <strong>Valeur :</strong> {{ formatNumber(mutation.properties.valeurfonc, 2) }} €
                            </p>
                            <p>
                                <strong>Nombre de bien(s) :</strong> {{mutation.properties.nblocmai + mutation.properties.nblocapt }}
                            </p>
                            <p>
                                <strong>Surface :</strong> {{ formatNumber(mutation.properties.sbati, 0) }}m²
                            </p>
                            <p class="num">
                                <span>{{ i + 1 }}</span>
                            </p>
                        </q-card-section>
                    </q-card>
                </l-icon>
            </l-marker>
        </template>
        <v-marker-cluster :ref="'cluster_prg'" key="cluster_prg" :options="{
            maxClusterRadius: 15,
            iconCreateFunction: iconCreateClsPrg,
            spiderfyDistanceMultiplier: 3
        }" @click="cluster_prg_click()" @clusterclick="cluster_prg_clusterclick()"
            @spiderfied="cluster_prg_spiderfied()" @unspiderfied="cluster_prg_unspiderfied()">
            <l-marker v-for="(programme, i) in programmes" :key="i + 'programme.nom'" :lat-lng="[
                parseFloat(programme.location.lat),
                parseFloat(programme.location.lon),
            ]" @click="$emit('select_marker', i)">
                <l-icon :prop-display=programme.display :class-name="
                    (programme.display == false ? 'custom-marker notDisplay'
                        : selected_markers.indexOf(i) > -1 ? 'custom-marker-selected'
                            : programme.forme_urbaine == 'INDIVIDUEL' ? 'custom-marker individuel'
                                : 'custom-marker') + (selected_markers.indexOf(i) > -1
                                    ? ' i_' + (selected_markers.indexOf(i) + 1) : '')
                ">
                    <p class="num">{{selected_markers.indexOf(i) > -1 ? selected_markers.indexOf(i) + 1: ""}}</p>
                    <q-card class="hovered">
                        <q-card-section class="section">
                            <div style="display: flex; width: 100%">
                                <img :src="programme.url_photo" style="max-width: 130px !important; max-height: 150px !important;" />
                                <div style="width: 150px !important; padding-left: 4px">
                                    <p class="name">{{ programme.nom }}</p>
                                    <p>{{ programme.promoteur }}</p>
                                    <p>Forme Urbaine : {{ programme.forme_urbaine }}</p>
                                    <p>Stock initial :{{ programme.stock_initial }} logement{{ programme.stock_initial > 1 ? "s" : ""}}</p>
                                    <p>{{ programme.adresse }}</p>
                                    <p>Commercialisation : {{ programme.date_commercialisation | format_date }}</p>
                                    <p v-if="programme.offre">Offre : {{ programme.offre }}</p>
                                    <p v-if="programme.surface_moyenne">Surface habitable : {{ programme.surface_moyenne }} m²</p>
                                    <p v-if="programme.vente_mois">
                                        {{new Intl.NumberFormat("fr-FR").format(programme.vente_mois.replace(",", "."))}}
                                        vente{{Math.trunc(Math.abs(parseFloat(programme.vente_mois.replace(",", ".")))) > 1 ? "s" : ""}}par mois
                                    </p>
                                    <p v-if="programme.part_invest">Part investisseur : {{ programme.part_invest }}%</p>
                                    <p v-if="programme.financements">Financement : {{ programme.financements }}</p>
                                    <p v-if="programme.tva_pleine_aide_prix_m2_parking_sans && programme.tva_pleine_aide_prix_m2_parking_sans > 0">
                                        prix tva pleine aidé :
                                        {{new Intl.NumberFormat("fr-FR").format(programme.tva_pleine_aide_prix_m2_parking_sans.replace(",","."))}}
                                        €/m² hors stat.
                                    </p>
                                    <p v-if="programme.tva_pleine_libre_prix_m2_parking_sans &&programme.tva_pleine_libre_prix_m2_parking_sans > 0">
                                        prix tva pleine libre :
                                        {{new Intl.NumberFormat("fr-FR").format(programme.tva_pleine_libre_prix_m2_parking_sans.replace(",","."))}}
                                        €/m² hors stat.
                                    </p>
                                    <p v-if="programme.tva_reduite_prix_m2_parking_sans &&programme.tva_reduite_prix_m2_parking_sans > 0">
                                        prix tva réduite :
                                        {{new Intl.NumberFormat("fr-FR").format(programme.tva_reduite_prix_m2_parking_sans.replace(",","."))}}
                                        €/m² hors stat.
                                    </p>
                                    <p v-if="programme.tva_pleine_aide_prix_m2_parking_avec && programme.tva_pleine_aide_prix_m2_parking_avec > 0">
                                        prix tva pleine aidé :
                                        {{new Intl.NumberFormat("fr-FR").format(programme.tva_pleine_aide_prix_m2_parking_avec.replace(",","."))}}
                                        €/m² avec stat.
                                    </p>
                                    <p v-if="programme.tva_pleine_libre_prix_m2_parking_avec &&programme.tva_pleine_libre_prix_m2_parking_avec > 0">
                                        prix tva pleine libre :
                                        {{new Intl.NumberFormat("fr-FR").format(programme.tva_pleine_libre_prix_m2_parking_avec.replace(",","."))}}
                                        €/m² avec stat.
                                    </p>
                                    <p v-if="programme.tva_reduite_prix_m2_parking_avec && programme.tva_reduite_prix_m2_parking_avec > 0">
                                        prix tva réduite :
                                        {{new Intl.NumberFormat("fr-FR").format(programme.tva_reduite_prix_m2_parking_avec.replace(",","."))}}
                                        €/m² avec stat.
                                    </p>
                                    <!-- <p>FILTERS</p>
            <p v-if="programme">filter_tva_pleine : {{ programme.filter_tva_pleine }}</p>
            <p v-if="programme">filter_tva_reduite : {{ programme.filter_tva_reduite }}</p>
            <p v-if="programme">filter_termine : {{ programme.filter_etat_commercialisation_termine }}</p> -->
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </l-icon>
            </l-marker>
        </v-marker-cluster>
        <template v-if="!linkedToView && !view" v-for="(programme, i) in selected_markers">
            <l-marker v-if="programmes[programme]" :key="i" :lat-lng="
                popup_positions.find((p) => {
                    return p.id == programmes[programme].id;
                })
                    ? [
                        parseFloat(
                            popup_positions.find((p) => {
                                return p.id == programmes[programme].id;
                            }).lat
                        ),
                        parseFloat(
                            popup_positions.find((p) => {
                                return p.id == programmes[programme].id;
                            }).lng
                        ),
                    ]
                    : [0, 0]
            " draggable @update:lat-lng="$emit('update_pos',$event, programmes[programme].id)">
                <l-icon class-name="selected-card">
                    <q-card class="selected">
                        <q-card-section>
                            <p class="name">{{ programmes[programme].nom }}</p>
                            <p>{{ programmes[programme].promoteur }}</p>
                            <!-- <p>{{ programmes[programme].forme_urbaine }}</p> -->
                            <p>
                                {{ programmes[programme].stock_initial }}
                                logement
                                {{programmes[programme].stock_initial > 1 ? "s" : "" }}
                            </p>
                            <!-- <p>{{ programmes[programme].adresse }}</p> -->
                            <!-- <p v-if="programmes[programme].date_commercialisation">Commercialisation : {{format_date(programmes[programme].date_commercialisation)}}</p> -->
                            <!-- <p v-if="programmes[programme].offre">Offre : {{ programmes[programme].offre }}</p> -->
                            <p v-if="programmes[programme].vente_mois">
                                {{new Intl.NumberFormat("fr-FR").format(programmes[programme].vente_mois.replace(",", "."))}}
                                vente{{
                                    Math.trunc(
                                        Math.abs(
                                            parseFloat(
                                                programmes[programme].vente_mois.replace(",", ".")
                                            )
                                        )
                                    ) > 1 ? "s" : ""
                                }}
                                par mois
                            </p>
                            <!-- <p v-if="programmes[programme].part_invest">Part investisseur : {{ programmes[programme].part_invest }}%</p> -->
                            <!-- <p v-if="programmes[programme].financements">Financement : {{ programmes[programme].financements }}</p> -->
                            <!-- <p v-if="programmes[programme].prix_m2">{{new Int l.NumberFormat('fr-FR').format((programmes[programme].prix_m2).replace(",","."))}}€/m² hors stat.</p> -->
                            <p v-if="programmes[programme].forme_urbaine == 'INDIVIDUEL'">
                                {{ getPrixPUMIntoSelectedCard(programmes[programme]) }} €
                            </p>
                            <p v-else>
                                <span v-html="getPrixIntoSelectedCard(programmes[programme])">
                                </span>
                            </p>
                            <p class="num">
                                <span>{{ i + 1 }}</span>
                            </p>
                        </q-card-section>
                    </q-card>
                </l-icon>
            </l-marker>
        </template>
        <l-marker v-for="(programme, i) in hard_coded_programs" :key="'hardpop' + i"
				:lat-lng="programme.popup_location" draggable
				@update:lat-lng="$emit('update_pos_hard_point',$event, i, 'popup_location')" @click="$emit('select_hardcoded',i)"
				v-if="(!view && !linkedToView) || programme.prog_type == 'annotation'">
				<l-icon class-name="selected-card">
					<q-card class="selected"
						:class="{ transparent: text_only_program || programme.prog_type == 'annotation' }">
						<q-card-section>
							<p class="name" :class="{annotation : programme.prog_type == 'annotation' }">{{ programme.nom }}</p>
							<p v-if="programme.promoteur">{{ programme.promoteur }}</p>
							<p v-if="programme.forme_urbaine">{{ programme.forme_urbaine }}</p>
							<p v-if="programme.stock_initial">
								{{ programme.stock_initial }} logement{{
									programme.stock_initial > 1 ? "s" : ""
								}}
							</p>
							<p v-if="programme.adresse">{{ programme.adresse }}</p>
							<p v-if="programme.date_commercialisation">
								Commercialisation :
								{{ programme.date_commercialisation | format_date }}
							</p>
							<p v-if="programme.offre">Offre : {{ programme.offre }}</p>
							<p v-if="programme.vente_mois">
								{{
									new Intl.NumberFormat("fr-FR").format(
										programme.vente_mois.replace(",", ".")
									)
								}}
								vente{{
									Math.trunc(
										Math.abs(parseFloat(programme.vente_mois.replace(",", ".")))
									) > 1
										? "s"
										: ""
								}}
								par mois
							</p>
							<p v-if="programme.part_invest">
								Part investisseur : {{ programme.part_invest }}%
							</p>
							<p v-if="programme.financements">
								Financement : {{ programme.financements }}
							</p>
							<p v-if="programme.prix_m2">
								prix tva pleine libre {{
									new Intl.NumberFormat("fr-FR").format(
										programme.prix_m2.replace(",", ".")
									)
								}}€{{ programme.type == 'individuel' ? '' : '/m²' }}
								<strong><u>{{ programme.stat == "true" ? 'avec' : 'hors' }} stat.</u></strong>
							</p>
							<p class="num" v-if="!text_only_program && programme.prog_type !== 'annotation'">
								<span>{{ getProgrammeMarkerIndex(i) }}</span>
							</p>
						</q-card-section>
					</q-card>
				</l-icon>
			</l-marker>
    </div>
</template>
<script>
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";
import MapMixin from "@/components/study/editor/elements/cartographie/map.mixin.js";

export default {
	mixins: [ElementMixin, MapMixin],
	props: {
		linkedToView: {
			required: true
		},
		view: {
			required: true
		},
		popup_positions: {
			required: true
		},
		selected_markers: {
			required: true
		},
		programmes: {
			required: true
		},
		selected_mutations: {
			required: true
		},
		hard_coded_programs: {
			required: true
		},
		allow_programs: {
			required: true
		},
		text_only_program: {
			required: true
		}
	},
	computed: {
		getProgrammeMarkerIndex () {
			return (markerIndex) => {
				// Iterate only over markers that are not annotations (because index marker is not shown for annotation)
				const nbAnnotBeforeIndex = this.hard_coded_programs.slice(0, markerIndex).filter(program => program.prog_type === "annotation").length;
				return this.selected_markers.length + this.selected_mutations.length + markerIndex - nbAnnotBeforeIndex + 1;
			};
		},
	},
	methods: {
		formatNumber (value, decimals) {
			decimals = 10 ** (decimals);
			return Math.round(value * decimals) / decimals;
		},
		getPrixIntoSelectedCard: function (data) {
			const prix_aide = data.tva_pleine_aide_prix_m2_parking_avec > 0 ? data.tva_pleine_aide_prix_m2_parking_avec : data.tva_pleine_aide_prix_m2_parking_sans;
			const prix_libre = data.tva_pleine_libre_prix_m2_parking_avec > 0 ? data.tva_pleine_libre_prix_m2_parking_avec : data.tva_pleine_libre_prix_m2_parking_sans;
			const prix_reduit = data.tva_reduite_prix_m2_parking_avec > 0 ? data.tva_reduite_prix_m2_parking_avec : data.tva_reduite_prix_m2_parking_sans;
			const prix_aide_unit = data.tva_pleine_aide_prix_m2_parking_avec > 0 ? "avec" : "hors";
			const prix_libre_unit = data.tva_pleine_libre_prix_m2_parking_avec > 0 ? "avec" : "hors";
			const prix_reduit_unit = data.tva_reduite_prix_m2_parking_avec > 0 ? "avec" : "hors";

			let result = "";
			let unit = "";
			if (prix_libre > 0) {
				unit = prix_libre_unit;
				result = "prix tva pleine libre ".concat(prix_libre);
			} else if (prix_aide > 0) {
				unit = prix_aide_unit;
				result = "prix tva pleine aidé ".concat(prix_aide);
			} else {
				unit = prix_reduit_unit;
				result = "prix tva réduite ".concat(prix_reduit);
			}

			// add unit
			result += "€/m²  <strong><u>" + unit + " stat</u></strong>";

			return result;
		},
		getPrixPUMIntoSelectedCard: function (data) {
			const prix_aide = data.pum_tva_pleine_aide;
			const prix_libre = data.pum_tva_pleine_libre;
			const prix_reduit = data.pum_tva_reduite;
			let result = "";

			if (prix_libre > 0) {
				result = "prix tva pleine libre ".concat(prix_libre);
			} else if (prix_aide > 0) {
				result = "prix tva pleine aidé ".concat(prix_aide);
			} else {
				result = "prix tva réduite ".concat(prix_reduit);
			}

			//var result = "prix tva reduite : 0.0 €"
			return result;
		},
		cluster_prg_clusterclick () {
			if (this.$refs["cluster_prg"]) {
				this.$refs["cluster_prg"].mapObject.refreshClusters();
			}
		},
		cluster_prg_spiderfied () {
			if (this.$refs["cluster_prg"]) {
				this.$refs["cluster_prg"].mapObject.refreshClusters();
			}
		},
		cluster_prg_click () {
			if (this.$refs["cluster_prg"]) {
				this.$refs["cluster_prg"].mapObject.refreshClusters();
			}
		},
		cluster_prg_unspiderfied () {
			if (this.$refs["cluster_prg"]) {
				this.$refs["cluster_prg"].mapObject.refreshClusters();
			}
		},
		update_pos_mutation (mutation, coordinates, type) {
			this.$emit("toggleSelectedMutations", {
				...mutation,
				[`${type}_position`]: [coordinates.lat, coordinates.lng]
			}, true);
		},
		iconCreateClsPrg (marker_cluster) {
			const css_marker_selected = "custom-marker-grp-selected";
			const css_marker_selected_simple = "custom-marker-selected";
			const css_marker_selected_big = "custom-marker-grp-selected big-marker";
			const css_marker = "custom-marker-grp";

			const childCount = marker_cluster.getChildCount();
			let clusterId = "";
			let htmlContent = "";
			let nbSelected = 0;
			let nbHidden = 0;
			let nbChild = 0;
			let css_cluster = css_marker;
			let childId = "";

			try {
				const childs = marker_cluster.getAllChildMarkers();
				const promises = [];
				childs.forEach(child => {
					// create promise to wait for all child
					const promise = new Promise(resolve => {
						// wait for 0ms to let the browser render the page asynchonously
						setTimeout(() => {
							nbChild++;
							const cssCluster = child.options.icon.options.className;
							if (cssCluster && cssCluster.includes(css_marker_selected_simple)) {
								nbSelected++;
								childId = cssCluster.split("i_")[1];
								clusterId = clusterId.length > 0 ? clusterId + "." + childId : childId;
							}
							if (cssCluster && cssCluster.includes("notDisplay")) {
								nbHidden++;
							}
							resolve();
						}, 0);
					});
					promises.push(promise);
				});
				// wait for all child to be processed before continue
				Promise.all(promises).then(() => {
					//sort id in clusterId
					let ids = clusterId.split(".");
					ids = ids.sort();
					clusterId = ids.join(".");
					// manage css from number of id selected in cluster
					if (nbSelected > 2) {
						css_cluster = css_marker_selected_big;
						const clusterId_1 = ids.slice(0, 2).join(".");
						const clusterId_2 = ids.slice(2, 4).join(".");
						htmlContent = "<p class='num'>" + clusterId_1 + "</p><p class='num'>" + clusterId_2 + "</p>";
					}
					else if (nbSelected > 0) {
						css_cluster = css_marker_selected;
						htmlContent = "<p class='num'>" + clusterId + "</p>";
					} else {
						css_cluster = css_marker;
					}
					// hide cluster without enable child
					if (nbChild == nbHidden) {
						css_cluster = "custom-marker-grp notDisplay";
					}

					const divIcon = new L.DivIcon({
						html: htmlContent,
						className: css_cluster,
						iconSize: [30 + childCount, 30 + childCount],
					});

					// Ensure the map updates the cluster icon after the promise has resolved
					marker_cluster.setIcon(divIcon);
				});
			} catch (e) {
				console.error(e);
			}
			// Return a blank icon to start with
			return new L.DivIcon({
				className: css_marker,
				iconSize: [30 + childCount, 30 + childCount]
			});
		}
	}
};
</script>

<style lang="stylus">

.custom-marker-grp {
    border-color: #A32952;
}

.custom-marker-grp-selected {
    border: 3px solid #3e5d58 !important;
    z-index: 160 !important;
    background-color: white !important;
    color: #3e5d58;
    opacity: 1 !important;

    .num {
        text-align: center;
        font-size: 12px;

        span {
            position: relative;
            top: 4px;
        }
    }
    .selected {
        display: block !important;
        width: 150px !important;
        background: #FFFFFF;

        .name {
            font-size: 10px;
        }

        p {
            font-size: 8px;
        }
    }

    .hovered {
        display: none !important;
    }
}
.annotation {
    font-weight: bolder !important;
    font-size:16px !important;
    font-style: italic !important;
}
.custom-marker-selected.big-marker{
		width: 40px !important;
		height: 40px !important;
		border-radius: 20px;
	}

.custom-marker-grp-selected.big-marker{
    width: 40px !important;
    height: 40px !important;
    border-radius: 20px;
}

.custom-marker-selected {
    border: 3px solid #3e5d58;
    z-index: 160 !important;
    background-color: white !important;
    color: #3e5d58;
    opacity: 1 !important;

    .num {
        text-align: center;
        font-size: 12px;

        span {
            position: relative;
            top: 4px;
        }
    }
    .selected {
        display: block !important;
        width: 150px !important;
        background: #FFFFFF;

        .name {
            font-size: 10px;
        }

        p {
            font-size: 8px;
        }
    }

    .hovered {
        display: none !important;
    }
}

.custom-marker-grp, .custom-marker-grp-selected {
    border: 3px solid;
    background-color: #CC3367;
    opacity: 0.9;
    width: 24px !important;
    height: 24px !important;
    border-radius: 12px;
    z-index: 110 !important;
    .hovered, .selected {
        display: none;
        position: absolute;
        top: 24px;
        left: -63px !important;
        width: 300px;
        .name {
            font-weight: bold;
            font-size: 12px;
        }
        p {
            font-size: 10px;
        }
    }

    &:hover {
        z-index: 150 !important;
        .hovered {
            display: block;
        }
    }
}
</style>